import { Component, OnInit } from "@angular/core";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { ReportsService } from "../services/reports.service";

@Component({
  selector: "app-duplicate-document-report",
  templateUrl: "./duplicate-document-report.component.html",
  styleUrls: ["./duplicate-document-report.component.scss"],
})
export class DuplicateDocumentReportComponent implements OnInit {
  isLoading = false;
  summaryDocuments: any[] = [];
  selectedDocumentDetails: any[] = [];
  selectedDocumentName = "";
  selectedDocumentCount = 0;
  selectedDocumentId = 0;
  showDetailModal = false;
  showCustomerDetailModal = false;
  customerDetails: any[] = [];
  selectedDocNumber = "";

  private currentUser: any;

  constructor(
    private reportsService: ReportsService,
    private dataSharingService: DataSharingService
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Duplicate Document Report");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.loadDuplicateDocumentSummary();
  }

  loadDuplicateDocumentSummary(): void {
    this.isLoading = true;
    this.summaryDocuments = [];

    const requestPayload = {
      LoginUserId: this.currentUser?.userId || 0,
    };

    this.reportsService.Duplicate_Document_Report(requestPayload).subscribe({
      next: (response: any) => {
        this.summaryDocuments = this.extractSummaryRows(response);
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  onDocumentCountClick(documentRow: any): void {
    this.selectedDocumentId = Number(documentRow?.KYC_DocId || 0);
    this.selectedDocumentName = documentRow?.Doc_Name || "Document";
    this.selectedDocumentCount = Number(documentRow?.Duplicate_Count || 0);
    this.showDetailModal = true;
    this.selectedDocumentDetails = [];
    this.loadDuplicateDocumentDetails(documentRow);
  }

  loadDuplicateDocumentDetails(documentRow: any): void {
    const requestPayload = {
      docId: documentRow?.KYC_DocId || 0,
      LoginUserId: this.currentUser?.userId || 0,
    };

    this.reportsService.Duplicate_Document_Report(requestPayload).subscribe({
      next: (response: any) => {
        const allDetailRows = this.extractDetailRows(response);
        this.selectedDocumentDetails = allDetailRows.filter(
          (row: any) => Number(row?.KYC_DocId || 0) === this.selectedDocumentId
        );
      },
      error: () => {
        this.selectedDocumentDetails = [];
      },
    });
  }

  closeDetailModal(): void {
    this.showDetailModal = false;
    this.showCustomerDetailModal = false;
    this.customerDetails = [];
    this.selectedDocNumber = "";
    this.selectedDocumentId = 0;
    this.selectedDocumentName = "";
    this.selectedDocumentCount = 0;
    this.selectedDocumentDetails = [];
  }

  onViewCustomerDetails(detailRow: any): void {
    const documentNumber =
      detailRow?.KYC_DocNumber ||
      detailRow?.Doc_No ||
      detailRow?.Document_No ||
      detailRow?.DocNumber ||
      detailRow?.KYC_Doc_No ||
      "";

    this.selectedDocNumber = documentNumber;
    this.showCustomerDetailModal = true;
    this.customerDetails = [];

    const requestPayload = {
      DocId: this.selectedDocumentId,
      DocNumber: documentNumber,
    };

    this.reportsService
      .Duplicate_Document_Report_Detail(requestPayload)
      .subscribe({
        next: (response: any) => {
          this.customerDetails = this.extractCustomerRows(response);
        },
        error: () => {
          this.customerDetails = [];
        },
      });
  }

  closeCustomerDetailModal(): void {
    this.showCustomerDetailModal = false;
    this.customerDetails = [];
    this.selectedDocNumber = "";
  }

  private extractSummaryRows(response: any): any[] {
    if (Array.isArray(response)) {
      if (response.length > 0 && Array.isArray(response[0])) {
        return response[0];
      }
      return response;
    }
    if (response?.Item1 && Array.isArray(response.Item1)) {
      return response.Item1;
    }
    if (response?.item1 && Array.isArray(response.item1)) {
      return response.item1;
    }
    if (response?.Data && Array.isArray(response.Data)) {
      return response.Data;
    }
    return [];
  }

  private extractDetailRows(response: any): any[] {
    if (Array.isArray(response)) {
      if (response.length > 0 && Array.isArray(response[0])) {
        return response[0];
      }
      return response;
    }
    if (response?.Item2 && Array.isArray(response.Item2)) {
      return response.Item2;
    }
    if (response?.item2 && Array.isArray(response.item2)) {
      return response.item2;
    }
    if (response?.Item1 && Array.isArray(response.Item1)) {
      return response.Item1;
    }
    if (response?.item1 && Array.isArray(response.item1)) {
      return response.item1;
    }
    if (response?.Data && Array.isArray(response.Data)) {
      return response.Data;
    }
    return [];
  }

  private extractCustomerRows(response: any): any[] {
    if (Array.isArray(response)) {
      if (response.length > 0 && Array.isArray(response[0])) {
        return response[0];
      }
      return response;
    }
    if (response?.Item1 && Array.isArray(response.Item1)) {
      return response.Item1;
    }
    if (response?.item1 && Array.isArray(response.item1)) {
      return response.item1;
    }
    if (response?.Item2 && Array.isArray(response.Item2)) {
      return response.Item2;
    }
    if (response?.item2 && Array.isArray(response.item2)) {
      return response.item2;
    }
    if (response?.Data && Array.isArray(response.Data)) {
      return response.Data;
    }
    return [];
  }

  getDocumentIcon(docName: string): string {
    const name = (docName || "").toLowerCase();
    if (name.includes("aadhar") || name.includes("adhar")) return "fa-id-card";
    if (name.includes("pan")) return "fa-address-card";
    if (name.includes("voter")) return "fa-user-check";
    if (name.includes("passport")) return "fa-passport";
    if (name.includes("driving") || name.includes("dl")) return "fa-id-badge";
    if (name.includes("ration")) return "fa-book";
    return "fa-file-alt";
  }

  getDocumentColor(docName: string): string {
    const name = (docName || "").toLowerCase();
    if (name.includes("aadhar") || name.includes("adhar")) return "#4a90e2";
    if (name.includes("pan")) return "#f5a623";
    if (name.includes("voter")) return "#7ed321";
    if (name.includes("passport")) return "#9013fe";
    if (name.includes("driving") || name.includes("dl")) return "#50e3c2";
    return "#4a4a4a";
  }
}
